import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'email-config',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./EmailConfig').default
      callback(null, component)
    }, 'EmailConfig')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/EmailConfig/index.js